import { Field } from 'react-final-form';
import { required } from '../../helpers';
import useFetchCountries from '../../hooks/useFetchCountries';
import FormError from '../Common/FormError';

const BorrowerAddress = () => {
  const { countries, provinces, handleSelectCountry } = useFetchCountries();

  return (
    <>
      <label className='form-label fs-4 text-capitalize'>Tell us where you live</label>
      <div className='mb-5 col-lg-12'>
        <Field name='address' type='textarea' validate={(v) => required(v, 'Address')}>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                <input type='text' {...input} placeholder='Address' className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>

      <div className='mb-5 col-lg-12'>
        <Field name='city' type='text' validate={(v) => required(v, 'City')}>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                <input type='text' placeholder='City' {...input} className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>

      <div className='row'>
        <div className='mb-5 col-lg-6'>
          <Field name='country' type='select' validate={(v) => required(v, 'Country')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <select
                    {...input}
                    className='form-select form-select-lg form-select-solid'
                    onChange={(e) => {
                      input.onChange(e);
                      handleSelectCountry(e);
                    }}>
                    <option value=''>Country</option>
                    {countries.length &&
                      countries.map((country) => {
                        return (
                          <option key={country.id} value={country.id}>
                            {country.name}
                          </option>
                        );
                      })}
                  </select>
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>
        <div className='mb-5 col-lg-6'>
          <Field name='state' type='select' validate={(v) => required(v, 'State/Province')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <select {...input} className='form-select form-select-lg form-select-solid'>
                    <option value='' defaultValue=''>
                      State/Province
                    </option>
                    {provinces.map((state) => {
                      return (
                        <option key={state.id} value={state.id}>
                          {state.name}
                        </option>
                      );
                    })}
                  </select>
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>
      </div>
    </>
  );
};

export default BorrowerAddress;
